<template>
    <b-modal
        :hide-footer="true"
        centered
        size="xl"
        id="update-modal"
        :title="comunicado.title"
    >
        <!-- <load v-if="loading" mode="table" /> -->
        <div class="row">
            <div
                class="col-12 my-4"
                style="overflow: auto; display: block; max-height: 600px"
                v-html="comunicado.text"
            ></div>
        </div>
    </b-modal>
</template>
<script>
export default {
    props: ["comunicado"],
};
</script>
